import React, { Component } from 'react';
import $ from 'jquery'
import ReactHtmlParser from 'react-html-parser';
import MetaTags from 'react-meta-tags';
import PressReleaseRight from "./PressReleaseRight/PressReleaseRight";
class PressReleaseDesc extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content:'',
            title:'',
            img_path: '',
            slug   : props.match.params.slug,
            error: null,
            isLoaded:true
        };
        this.GetContentData(this.state.slug);
            localStorage.setItem('catData',"");

    }

    GetContentData(param) {

        let url = 'https://mordorintelligence.com:81/api/press-release/pressData?slug='+param;
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        content: result.content,
                        title : result.title,
                        img_path : result.img_path
                    });
                },
                (error) => {

                }
            )

    }

    render() {

        return (

            <section class="ovrfl">
                <MetaTags>
                    <title>{this.state.title }</title>
                    <meta id="description" name="description" content={ReactHtmlParser(this.state.content)} />
                    <meta id="keywords" name="keywords" content={this.state.title } />
                </MetaTags>
                <div class="container flash_con_pad">
                    <div class="row breadcrumb text-center trght">
                        <div class="col-md-12"> <a href="/"><span>Home</span></a><i class="fa fa-angle-right"></i> <a href="/press-release"><span>Press Release </span></a> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="reportd_pic"><img src={'https://mordorintelligence.com:81/images_db/' + this.state.img_path } data-src={'https://mordorintelligence.com:81/images_db/' + this.state.img_path } class="img-responsive" alt={this.state.slug}></img></div>
                                    <div class="reportd_title">
                        	<span>
							<p>
                            	February 2018
								</p>
							</span>
                                        <h1> {this.state.title }</h1>


                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 re_desctable press_deta_mar">
                                    <div class="tab-content">
                                        <div id="home" class="tab-pane fade in active">
                                            <p>{ReactHtmlParser(this.state.content)}</p>
                                            <div class="asu">

                                            </div>
                                            <div class="social-ico"><span>SHARE</span>
                                                <i class="fa fa-linkedin social-icons"></i>
                                                <i class="fa fa-envelope-o social-icons"></i>
                                                <i class="fa fa-twitter social-icons"></i>
                                                <i class="fa fa-google-plus social-icons"></i>
                                            </div>

                                        </div>


                                    </div>
                                </div>


                            </div>




                        </div>
                      <PressReleaseRight/>
                    </div>


                </div>
            </section>

        );

    }


}
export default PressReleaseDesc;


// WEBPACK FOOTER //
// ./src/press-release/press-release-description/PressReleaseDesc.js